import React, { type FC } from 'react'
import { styled } from '@linaria/react'
import { useNavigate, useLocation } from 'react-router'
import { FormattedMessage } from 'react-intl'
import { Typography } from '../ui/Typography'
import { ButtonRegular } from '../ui/Button'
import ArrowBack from '../svgr/ArrowBack'
import { colors } from '../styles/colors'

export const NotFoundPage: FC = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1)
    } else {
      navigate('/')
    }
  }

  return (
    <Container>
      <Content>
        <IconContainer>
          <Typography fontSize={28} fontWeight={700} font="manrope">
            404
          </Typography>
        </IconContainer>

        <Typography fontSize={24} fontWeight={700} font="manrope">
          <FormattedMessage
            id="notFound.title"
            defaultMessage="Страница не найдена"
          />
        </Typography>

        <Typography fontSize={16}>
          <FormattedMessage
            id="notFound.description"
            defaultMessage="К сожалению, запрашиваемая страница не существует или была перемещена."
          />
        </Typography>

        <RouteInfo fontSize={14} color={colors.grey600}>
          <FormattedMessage
            id="notFound.route"
            defaultMessage="Запрашиваемый путь: {route}"
            values={{ route: location.pathname }}
          />
        </RouteInfo>

        <ButtonContainer>
          <ButtonRegular onClick={handleGoBack}>
            <ButtonContent>
              <ArrowBack style={{ marginRight: '8px', fill: colors.white }} />

              <FormattedMessage id="notFound.goBack" defaultMessage="Назад" />
            </ButtonContent>
          </ButtonRegular>
        </ButtonContainer>
      </Content>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  background: ${colors.white};
`

const Content = styled.div`
  display: grid;
  gird-gap: 12px;
  justify-items: center;
  max-width: 400px;
  width: 100%;
  text-align: center;
`

const IconContainer = styled.div`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ButtonContainer = styled.div`
  width: 100%;
  max-width: 280px;
`

const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
    color: currentColor;
  }
`

const RouteInfo = styled(Typography)`
  margin-top: 16px;
  padding: 8px 12px;
  background: ${colors.grey100};
  border-radius: 8px;
  word-break: break-all;
`
